import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className={`fixed w-full transition-all duration-500 z-50 shadow-sm ${
  scrolled ? 'bg-white  py-3 border-b border-gray-100' : 'bg-white/95 backdrop-blur-sm py-4'
}`}>
  <div className="container mx-auto px-6">
    <div className="flex justify-between items-center">
      {/* Logo with subtle hover animation */}
      <Link to="/" className="flex items-center group">
        <img 
          src="/logo.png" 
          alt="EquiCore Nexus Logo"
          className="h-10 mr-3 transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <span className="text-2xl font-bold text-gray-900">
          <span className="bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent transition-all duration-500 group-hover:from-blue-700 group-hover:to-emerald-700">
            EquiCore
          </span>
          <span className="text-gray-800">Nexus</span>
        </span>
      </Link>
      
      {/* Desktop Navigation */}
      <nav className="hidden lg:flex items-center space-x-1">
        <a 
          href="/#about" 
          className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium transition-all duration-300 relative group"
        >
          About
          <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-4/5 group-hover:left-[10%]"></span>
        </a>
        <a 
          href="/#services" 
          className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium transition-all duration-300 relative group"
        >
          Expertise
          <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-4/5 group-hover:left-[10%]"></span>
        </a>
        <a 
          href="/#portfolio" 
          className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium transition-all duration-300 relative group"
        >
          Case Studies
          <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-4/5 group-hover:left-[10%]"></span>
        </a>
        <a 
          href="/#whyus" 
          className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium transition-all duration-300 relative group"
        >
          Why Us
          <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-4/5 group-hover:left-[10%]"></span>
        </a>
        <div className="w-px h-6 bg-gray-200 mx-2"></div>
        <a 
          href="/#contact" 
          className="ml-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-6 py-2.5 rounded-md font-medium transition-all duration-300 hover:shadow-md hover:-translate-y-0.5"
        >
          Get Started
        </a>
      </nav>
      
      {/* Mobile Menu Toggle */}
      <button 
        className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none transition-colors duration-300"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <svg 
          className={`w-6 h-6 transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          />
        </svg>
      </button>
    </div>
    
    {/* Mobile Menu - Animated dropdown */}
    <div className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out ${
      isOpen ? 'max-h-96 py-4 border-t border-gray-100 mt-3' : 'max-h-0 py-0'
    }`}>
      <div className="flex flex-col space-y-3 px-2">
        <a 
          href="/#about" 
          className="px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-blue-50 font-medium transition-colors duration-300"
          onClick={closeMenu}
        >
          About
        </a>
        <a 
          href="/#services" 
          className="px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-blue-50 font-medium transition-colors duration-300"
          onClick={closeMenu}
        >
          Expertise
        </a>
        <a 
          href="/#portfolio" 
          className="px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-blue-50 font-medium transition-colors duration-300"
          onClick={closeMenu}
        >
          Case Studies
        </a>
        <a 
          href="/#whyus" 
          className="px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-blue-50 font-medium transition-colors duration-300"
          onClick={closeMenu}
        >
          Why Us
        </a>
        <a 
          href="/#contact" 
          className="mt-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-6 py-3 rounded-lg font-medium text-center transition-all duration-300 hover:shadow-md"
          onClick={closeMenu}
        >
          Get Started
        </a>
      </div>
    </div>
  </div>
</header>
  );
};

export default Navbar;